import { Component, inject } from '@angular/core';
import { CommonService } from '../shared/services/common.service';
import { Router } from '@angular/router';
import { AuthService } from '../shared/modules/auth/services/auth.service';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-not-authorized',
  imports: [Button],
  templateUrl: './not-authorized.component.html',
  styleUrl: './not-authorized.component.scss',
})
export class NotAuthorizedComponent {
  private commonService = inject(CommonService);
  private router = inject(Router);

  constructor() {}

  ngOnInit() {
    this.commonService.pageHeader = {
      headerText1: undefined,
      headerValue1: undefined,
      headerText2: undefined,
      headerValue2: undefined,

      pageTitle: 'Not Authorized',

      subTitle: undefined,
    };
  }

  async redirectAndLogin() {
    Object.keys(localStorage)
      .filter((k) => k.toLowerCase().includes('msal'))
      .forEach((k) => localStorage.removeItem(k));
    await this.router.navigate(['/']);
    // await this.authService.logoutSilent();
  }
}
